import { render } from "./BudgetLayout.vue?vue&type=template&id=d19dc210"
import script from "./BudgetLayout.vue?vue&type=script&lang=js"
export * from "./BudgetLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__